/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Mock_Search_PlaceholderInputs */

const tr_landing_shortcuts_mock_search_placeholder = /** @type {(inputs: Landing_Shortcuts_Mock_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ara: sipariş, ürün, müşteri, mağaza...`)
};

const en_landing_shortcuts_mock_search_placeholder = /** @type {(inputs: Landing_Shortcuts_Mock_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`search: order, product, customer, store...`)
};

const de_landing_shortcuts_mock_search_placeholder = /** @type {(inputs: Landing_Shortcuts_Mock_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`suche: Bestellung, Produkt, Kunde, Shop...`)
};

const ru_landing_shortcuts_mock_search_placeholder = /** @type {(inputs: Landing_Shortcuts_Mock_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`поиск: заказ, товар, клиент, магазин...`)
};

/**
* | output |
* | --- |
* | "search: order, product, customer, store..." |
*
* @param {Landing_Shortcuts_Mock_Search_PlaceholderInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_mock_search_placeholder = /** @type {((inputs?: Landing_Shortcuts_Mock_Search_PlaceholderInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Mock_Search_PlaceholderInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_mock_search_placeholder(inputs)
	if (locale === "de") return de_landing_shortcuts_mock_search_placeholder(inputs)
	if (locale === "ru") return ru_landing_shortcuts_mock_search_placeholder(inputs)
	return tr_landing_shortcuts_mock_search_placeholder(inputs)
});